import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CursHero } from '../components/curs/CursHero';
import { CursProblem } from '../components/curs/CursProblem';
import { CursCurriculum } from '../components/curs/CursCurriculum';
import { CursBenefits } from '../components/curs/CursBenefits';
import { CursAbout } from '../components/curs/CursAbout';
import { CursForWho } from '../components/curs/CursForWho';
import { CursPricing } from '../components/curs/CursPricing';
import { CursTestimonials } from '../components/curs/CursTestimonials';
import { CursFAQ } from '../components/curs/CursFAQ';
export function CursPage() {
  return <div className="min-h-screen bg-brand-cream font-body text-brand-text selection:bg-brand-gold selection:text-white overflow-x-hidden" data-id="element-2327">
      <Header data-id="element-2328" />
      <main data-id="element-2329">
        <CursHero data-id="element-2330" />
        <CursProblem data-id="element-2331" />
        <CursCurriculum data-id="element-2332" />
        <CursBenefits data-id="element-2333" />
        <CursAbout data-id="element-2334" />
        <CursForWho data-id="element-2335" />
        <CursPricing data-id="element-2336" />
        <CursTestimonials data-id="element-2337" />
        <CursFAQ data-id="element-2338" />
      </main>
      <Footer data-id="element-2339" />
    </div>;
}